function isAccessible(tab) {
  return !(tab.hasAttribute("disabled") || tab.ariaDisabled === "true");
}
export {
  isAccessible
};
